import React from "react";

const ValidatingScreen = () => (
  <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center p-4">
    <div className="bg-gray-800/50 backdrop-blur-sm rounded-3xl p-6 text-center border border-gray-700/50">
      <div className="animate-spin rounded-full h-8 w-8 border-2 border-white border-t-transparent mx-auto mb-3"></div>
      <p className="text-white text-sm">Validating...</p>
    </div>
  </div>
);

export default ValidatingScreen;
